module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABXklEQVRYR+2XMUvDUBDH/xcLDoLurtqx2tAEks1P4aKzgl9C/RKCznbxU3RLoCmpdoyu7goOQs3JqyYmpW1ekoIZ7kHIkLvL/37v3eOO0LBFDdMDEVS0IzlCQTDZmyI+Zo43lzmSQa/Ahu/0Ok+rgvujyQHw5XDMu0tjkfHZgvFgWZ2XxCYnyAvCCIz9oixm34n6tLN14bTb71l7P4q2+e3jBswnenHw7Fpme7GgYchaQVJv6rtW9zTr4wXje20xv46ubaZg8oTKClKgjNZhsn1qmziePpZKCsCaBdG50+veKRH+aHzGMd/+qyAA165tXikR3jBU70sRNEdACBUdCSEkhFICXoWbWu6hogMkhIRQrrmSKvvBsdYGTapMqqzZVVZmUPzLpF6DRisGRZ1RWuNMaZtQ0SitHSljODf6pLSqxJpN6FUdE78mCjoCoB61Bq5tDuokWZtQnZ8v8v0GxhMrNI3SQf4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/course/ico5.png
// module id = SwIX
// module chunks = 1